import React from 'react';
import {
  BedIcon,
  Building07Icon,
  DotIcon,
  MarkerPinIcon01,
  ToolIcon02,
  UnitSizeIcon,
  UserOneIcon,
  WalletIcon03,
} from '../../../../../../assets/icons';
import './LeadXChangeCard.scss';
import { CopyToClipboardComponents } from '../../../../../../ReusableComponents/UtilityComponents';
import moment from 'moment';
import { CheckboxesComponent } from '../../../../../../Components';
import LeadXChangeCardActions from './LeadXChangeCardActions';
import { useLeadXchangeData } from '../Context/LeadXchangeData';
import AEDIcon from '../../../../../../assets/icons/AEDIcon';

function LeadXChangeCard({ leadData, reload , setLoading }) {
  const { actionableItems, setActionableItems, userInfo } =
    useLeadXchangeData();

  const removeHandler = (id) => {
    setActionableItems((prev) => ({
      ...prev,
      selectedIds: prev.selectedIds.filter((selectedId) => selectedId !== id),
    }));
  };

  const selectHandler = (id) => {
    setActionableItems((prev) => ({
      ...prev,
      selectedIds: [...prev.selectedIds, id],
    }));
  };

  const onCardCheckboxClick = (id) => {
    const item = actionableItems.selectedIds.find(
      (selectedId) => selectedId === id
    );
    if (item) {
      removeHandler(id);
    } else {
      selectHandler(id);
    }
  };
  const formatSourceNameWithId = (sourceName) => {
    switch (sourceName) {
      case 'ASSETS_BRANCH':
        return `ASSETS/`;
      case 'AUH_BRANCH':
        return `Abu Dhabi/`;
      case 'DXB_BRANCH':
        return `Dubai/`;
      default:
        return `${sourceName || '—'}`;
    }
  };

  return (
    <div className='leadxchange-card-container'>
      <div className='leadxchange-card-title-wrapper'>
        {actionableItems.action && (
          <CheckboxesComponent
            idRef='contactsCheckboxItemRef'
            singleChecked={actionableItems?.selectedIds?.includes(
              leadData.sharedLeadId
            )}
            onSelectedCheckboxChanged={() =>
              onCardCheckboxClick(leadData.sharedLeadId)
            }
          />
        )}

        <div className='leadxchange-card-img-container'>
          <div className='leadxchange-card-img-wrapper'>
            <div className='leadxchange-card-img'>
              <UserOneIcon
                width='36'
                height='36'
                fill={'#667085'}
              />
            </div>
          </div>
        </div>
        <div className='leadxchange-card-name-wrapper'>
          <div className='leadxchange-card-name'>
            {leadData?.contactName || '—'}
          </div>
          <div className='leadxchange-card-role'>
            <div className='leadxchange-card-chip'>
              {leadData?.leadClass?.name || '—'}
            </div>
            <div className='leadxchange-card-id'>
              <span>
                {formatSourceNameWithId(
                  leadData?.leadExchangePoolSource?.sourceName
                )}
              </span>
              <CopyToClipboardComponents
                data={leadData?.crmLeadId}
                childrenData={leadData?.crmLeadId}
                CustomizationClassName='leadxchange-card-id-copy'
              />
            </div>
          </div>
        </div>
      </div>

      <div className='leadxchange-card-location-wrapper'>
        <div className='leadxchange-card-info'>
          <MarkerPinIcon01
            width='20'
            height='20'
            fill={'#98A2B3'}
          />
          <div className='leadxchange-card-info-text'>
            {leadData?.distrct || leadData?.community || leadData?.city
              ? `${leadData?.city},${leadData?.distrct || '—'}, ${
                  leadData?.community || '—'
                }`
              : '—'}
          </div>
        </div>
        <div className='leadxchange-card-info'>
          <ToolIcon02
            width='20'
            height='20'
            fill={'#98A2B3'}
          />
          <div className='leadxchange-card-info-text'>
            {leadData?.developerName || '—'}
          </div>
        </div>
        <div className='leadxchange-card-info'>
          <Building07Icon
            width='20'
            height='20'
            fill='#98A2B3'
          />
          <div className='leadxchange-card-info-text'>
            {leadData?.propertyName || '—'}
          </div>
        </div>
      </div>

      <div className='leadxchange-card-date-wrapper'>
        <div className='leadxchange-card-date'>
          <div className='leadxchange-card-info'>
            <UnitSizeIcon
              width='20'
              height='20'
              fill='#98A2B3'
            />
            <div className='leadxchange-card-info-text'>
              {`${parseInt(
                leadData.areaSizeFrom ?? 200
              ).toLocaleString()}-${parseInt(
                leadData.areaSizeTo ?? 10000
              ).toLocaleString()} sqft`}
            </div>
          </div>
          <div className='leadxchange-card-info'>
            <BedIcon
              width='20'
              height='20'
              fill='#98A2B3'
            />
            <div className='leadxchange-card-info-text'>
              {leadData?.Bedrooms
                ? leadData?.Bedrooms?.map((item) => item).join(', ')
                : '—'}
            </div>
          </div>
          <div className='leadxchange-card-info'>
            <WalletIcon03
              width='20'
              height='20'
              fill='#98A2B3'
            />
            <div className='leadxchange-card-info-text'>
              <>
                {`${parseInt(
                  leadData.budgetFrom ?? 10000
                ).toLocaleString()}-${parseInt(
                  leadData.budgetTo ?? 60000000
                ).toLocaleString()}`}
                <AEDIcon
                  width='16'
                  height='16'
                  aspect-ratio='1/1'
                  fill='#475467'
                />
              </>
            </div>
          </div>
        </div>

        <div className='leadxchange-card-status'>
          <div className='leadxchange-card-info-title'>Status</div>
          <div className='leadxchange-card-status-wrapper'>
            <DotIcon
              width='8'
              height='8'
              fill='#17B26A'
            />
            <span className='leadxchange-card-status-text'>
              {leadData.status.toLowerCase() === 'assigned'
                ? 'Claimed'
                : leadData.status}
            </span>
          </div>
        </div>

        <div className='leadxchange-card-status'>
          <div className='leadxchange-card-info-title'>Language</div>
          <div className='leadxchange-card-info-sub-text'>
            {leadData?.language || '—'}
          </div>
        </div>

        <div className='leadxchange-card-status'>
          <div className='leadxchange-card-info-title'>Shared On:</div>
          <div className='leadxchange-card-info-sub-text'>
            {leadData?.shareDate
              ? moment(leadData.shareDate).format('DD MMM YYYY')
              : '—'}
          </div>
        </div>
      </div>

      <div className='leadxchange-card-action'>
        <LeadXChangeCardActions
          leadData={leadData}
          isClaimed={leadData.status.toLowerCase() === 'assigned'}
          reload={reload}
          setLoading={setLoading}
        />
      </div>
    </div>
  );
}

export default LeadXChangeCard;
